import React from "react"
import { COLORS } from "../../../utilities/Constants"

// En-tête partagé des cartes de commande de l'inventaire (Commandes, Commandes
// Virtuelles, Stock Virtuel) → présentation uniforme. Fournisseur en titre, puis
// une rangée de pastilles : date (gris), référence (bleu), n° (vert), total
// (ambre). `reference`, `numero` et `total` sont optionnels (une commande
// normale n'a ni réf ni n°). `actions` = boutons à droite, propres à chaque carte.
const CommandeHeader = ({
	fournisseur,
	date,
	reference,
	numero,
	total,
	totalLabel = "CHF",
	perso,
	actions,
}) => (
	<div style={hs.head}>
		<div style={hs.left}>
			<div style={hs.title}>{fournisseur}</div>
			<div style={hs.subRow}>
				{date ? (
					<span style={{ ...hs.badge, ...hs.badgeDate }} title="Date">
						{date}
					</span>
				) : null}
				{reference ? (
					<span
						style={{ ...hs.badge, ...hs.badgeRef }}
						title={`Référence ${reference}`}
					>
						Réf {reference}
					</span>
				) : null}
				{numero ? (
					<span
						style={{ ...hs.badge, ...hs.badgeNum }}
						title={`Numéro de commande ${numero}`}
					>
						N° {numero}
					</span>
				) : null}
				{total != null ? (
					<span
						style={{ ...hs.badge, ...hs.badgeTotal }}
						title="Total"
					>
						{total} {totalLabel}
					</span>
				) : null}
			</div>
		</div>
		{perso || actions ? (
			<div style={hs.actions}>
				{perso ? (
					<span
						style={{ ...hs.badge, ...hs.badgePerso }}
						title="Commande personnelle"
					>
						Commande personnelle · {perso}
					</span>
				) : null}
				{actions}
			</div>
		) : null}
	</div>
)

const hs = {
	head: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 12,
		padding: "14px 18px",
		borderBottom: `1px solid ${COLORS.border}`,
	},
	left: { minWidth: 0 },
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	subRow: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 8,
		marginTop: 4,
	},
	// Pastille : fond, bordure et coins arrondis. La couleur (texte + fond +
	// bordure) est apportée par la variante.
	badge: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 600,
		border: "1px solid",
		whiteSpace: "nowrap",
	},
	badgeDate: {
		color: COLORS.textMuted,
		backgroundColor: COLORS.bg,
		borderColor: COLORS.border,
	},
	badgeRef: {
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
		borderColor: COLORS.accent,
	},
	badgeNum: {
		color: COLORS.success,
		backgroundColor: COLORS.successLight,
		borderColor: COLORS.success,
	},
	badgeTotal: {
		color: COLORS.warning,
		backgroundColor: COLORS.warningLight,
		borderColor: COLORS.warning,
	},
	badgePerso: {
		color: COLORS.danger,
		backgroundColor: COLORS.dangerLight,
		borderColor: COLORS.dangerBorder,
	},
	actions: { display: "flex", gap: 8, flexShrink: 0 },
}

export default CommandeHeader
